import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { themeReducer, configReducer } from '@kss/theme';
import { authReducer } from '@kss/auth';

/**
 * The customer signs in once and STAYS signed in across app closes/reopens until they
 * explicitly log out — so the auth slice persists in localStorage (was sessionStorage,
 * which logged them out whenever the tab closed). Theme preferences persist too.
 */
const authPersistConfig = {
  key: 'thalios-web-auth',
  storage
};

const rootReducer = combineReducers({
  theme: themeReducer,
  config: configReducer, // server-driven per-load; not persisted
  auth: persistReducer(authPersistConfig, authReducer)
});

const persistConfigRoot = {
  key: 'thalios-web',
  storage,
  whitelist: ['theme']
};

const persistedReducer = persistReducer(persistConfigRoot, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
